import React from 'react'
import PropTypes from 'prop-types'
import { AddMemberInvoiceForm } from '../../shared/components'

const AddMemberInvoiceComponent = ({ onSubmit, memberId }) => (
  <AddMemberInvoiceForm
    header="Add member invoice"
    memberId={memberId}
    onSubmit={onSubmit}
  />
)

AddMemberInvoiceComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  memberId: PropTypes.number.isRequired,
}

export default AddMemberInvoiceComponent
